import { render, staticRenderFns } from "./ActualityModal.vue?vue&type=template&id=2a32741c&scoped=true"
import script from "./ActualityModal.vue?vue&type=script&lang=js"
export * from "./ActualityModal.vue?vue&type=script&lang=js"
import style0 from "./ActualityModal.vue?vue&type=style&index=0&id=2a32741c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a32741c",
  null
  
)

export default component.exports